import React, { Suspense } from "react";

import { LoadingModule } from "@/components";

const PresenteeismgLazy = React.lazy(() => import("./PresenteeismRoutes"));

export default function ModuleLazy() {
  return (
    <Suspense fallback={<LoadingModule />}>
      <PresenteeismgLazy />
    </Suspense>
  );
}
